import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import { FooterMode, WizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { CreateTemplateSidebarMode } from '../create-template-sidebar';

export interface TemplateCreatedScreenProps {
  onClose: () => void;
  onView: () => void;
  mode?: CreateTemplateSidebarMode;
}

export const TemplateCreatedScreen = ({ onClose, onView, mode = 'report' }: TemplateCreatedScreenProps) => {
  const intl = useIntl();
  const isDashboard = mode === 'dashboard';

  return (
    <WizardScreen
      footerMode={FooterMode.CREATED}
      onCancel={onClose}
      onView={onView}
      viewText={intl.formatMessage({
        id: 'reporting.go_to_template',
        defaultMessage: 'Go to template'
      })}
    >
      <WizardFinished
        text={
          isDashboard
            ? intl.formatMessage({ id: 'reporting.dashboard_template_created_and_saved_as_draft', defaultMessage: 'Dashboard template created and saved as a draft for review' })
            : intl.formatMessage({ id: 'reporting.template_created_and_saved_as_draft', defaultMessage: 'Report template created and saved as a draft for review' })
        }
      />
    </WizardScreen>
  );
};
